import { LocationAlarmCamera } from '@hakimo-ui/hakimo/types';
import { Checkbox } from '@hakimo-ui/shared/ui-base';
import { VolumeOff } from 'lucide-react';
import { nameOf } from './CameraSelectPanel';

export function CameraRow(props: {
  camera: LocationAlarmCamera;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const { camera, checked, onChange } = props;

  if (!camera.isTalkdownEnabled) {
    return (
      <div className="flex items-center justify-between gap-2 py-1.5">
        <span className="text-onlight-text-3 dark:text-ondark-text-3 min-w-0 text-xs [overflow-wrap:anywhere]">
          {nameOf(camera)}
        </span>
        <VolumeOff
          className="text-onlight-text-3 dark:text-ondark-text-3 size-4 shrink-0"
          aria-label="No speaker reported for this camera"
        />
      </div>
    );
  }

  return (
    <div className="min-w-0 py-1.5">
      <Checkbox label={nameOf(camera)} checked={checked} onChange={onChange} />
    </div>
  );
}

export default CameraRow;
